import { render, staticRenderFns } from "./InstagramReportsTable.vue?vue&type=template&id=ad26b42e&"
import script from "./InstagramReportsTable.vue?vue&type=script&lang=js&"
export * from "./InstagramReportsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports